<div>
  <span class="go-calendar__header">
    <div class="go-calendar__header--outside">
      <go-icon-button
        class="go-calendar__icon"
        [buttonDisabled]="previousMonthDisabled"
        buttonIcon="keyboard_arrow_left"
        (handleClick)="previousMonth()"
      ></go-icon-button>
    </div>
    <div class="go-calendar__header--center go-calendar__header--center-offset">
      {{dateAdapter.monthNames[month]}} {{year.translated}}
      <div class="go-calendar__header-dropdown">
        <go-icon-button
          class="go-calendar__icon"
          buttonIcon="keyboard_arrow_down"
          (handleClick)="switchView()"
        ></go-icon-button>
      </div>
    </div>
    <div class="go-calendar__header--outside">
      <go-icon-button
        class="go-calendar__icon"
        [buttonDisabled]="nextMonthDisabled"
        buttonIcon="keyboard_arrow_right"
        (handleClick)="nextMonth()"
      ></go-icon-button>
    </div>
  </span>
</div>
<div class="go-calendar__body">
  <table class="go-calendar__table">
    <tr class="go-calendar__row">
      <th class="go-calendar__body--header go-calendar__body--header-border" *ngFor="let weekDay of dateAdapter.daysOfWeek">
        {{weekDay}}
      </th>
    </tr>
    <tr class="go-calendar__row">
      <td *ngFor="let weekDay of dateAdapter.daysOfWeek" class="go-calendar__body--padding"></td>
    </tr>
    <tr *ngFor="let week of weeks" class="go-calendar__row">
      <td *ngFor="let day of week" class="go-calendar__date">
        <span *ngIf="!day.translated"></span>
        <button
          class="go-calendar__cell go-calendar__cell--date"
          [disabled]="day.disabled"
          [ngClass]="{'go-calendar__cell--selected': day.selected, 'go-calendar__cell--focused': day.focused}"
          *ngIf="day.translated"
          (click)="pickDay(day.value)"
        >
          {{day.translated}}
        </button>
      </td>
    </tr>
  </table>
</div>
